import { Widget as RangoWidget, Refuel, SwapModeContext } from '@rango-dev/widget-embedded';
import React, { useMemo } from 'react';

import { useAppSelector } from '../../hooks/reduxHooks';
import { useSwapMode } from '../../hooks/useSwapMode';

type SwapModeContextType = {
  swapMode: 'swap' | 'refuel';
  isMultiMode: boolean;
};

export const Widget = () => {
  const widgetConfig = useAppSelector((state) => state.widget);

  const swapMode = useSwapMode();

  const swapModeContextValue: { swap: SwapModeContextType; refuel: SwapModeContextType } = useMemo(
    () => ({
      refuel: { swapMode: 'refuel', isMultiMode: true },
      swap: { swapMode: 'swap', isMultiMode: true },
    }),
    [],
  );

  if (swapMode === 'swap') {
    return (
      <SwapModeContext.Provider value={swapModeContextValue.swap}>
        <RangoWidget config={widgetConfig} />
      </SwapModeContext.Provider>
    );
  }

  return (
    <SwapModeContext.Provider value={swapModeContextValue.refuel}>
      <Refuel config={widgetConfig} />
    </SwapModeContext.Provider>
  );
};
